import { IconSvg, IconSvgProps } from "./icon"

export default function Check(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="m3.643 13.993 3.51 4.513a1.285 1.285 0 0 0 2.006.038L20.357 4.993" />
    </IconSvg>
  )
}
